var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.error
      ? _c("div", { staticClass: "c-message" }, [
          _c("div", { staticClass: "c-message__info has-error" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 18 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M9 0a9 9 0 109 9 9.026 9.026 0 00-9-9zm3.713 11.652l-1.061 1.06L9 10.06l-2.652 2.652-1.06-1.06L7.938 9 5.287 6.348l1.061-1.06L9 7.938l2.652-2.652 1.06 1.061L10.06 9l2.652 2.652z",
                    fill: "#DF2137"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", [_vm._v("Error:")]),
            _vm._v(" " + _vm._s(_vm.error) + "\n    ")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.selectedMovie
      ? _c("div", [
          _vm.selectedMovie.Slug
            ? _c("div", [_c("router-view")], 1)
            : _c("div", [_c("page404")], 1)
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }